import { combineReducers } from 'redux';

import session from '../../states/session/reducer';
import page from '../../states/page/reducer';
import envConfig from '../../states/envConfig/reducer';
import payments from '../../states/payments/reducer';
import accounts from '../../states/accounts/reducer';
import user from '../../states/user/reducer';
import api from '../../states/api/reducer';
import payees from '../../states/payees/reducer';
import rates from '../../states/rates/reducer';
import capabilities from '../../states/capabilities/reducer';

export default combineReducers({
	session,
	page,
	envConfig,
	payments,
	accounts,
	user,
	api,
	payees,
	rates,
	capabilities,
});
